import { gql } from '@/__generated__/gql';

export const STRATEGY_DETAILS_PAGE_GET_DOCUMENT_RECORD_QUERY = gql(`
  query StrategyDetailsPageGetDocumentRecord($id: String!) {
    getDocumentRecord(id: $id) {
      id
      name
      status
      statusUpdatedAt
      note
      createdAt
      updatedAt
      deletedAt
      sentimentFlag
      sentimentFlagLabel
      assignee {
        id
        firstName
        lastName
        email
      }
      publisher {
        id
        firstName
        lastName
        email
      }
      owner {
        id
        firstName
        lastName
        email
      }
      fields {
        id
        value
        commentary
        createdAt
        updatedAt
        deletedAt
        recordId
        fieldId
        labelerData {
          filename
          value
        }
        AI {
          answers
          answerJson
          summary
          citations {
            answer
            filename
            text
            embeddingId
            pageNumbers
            embeddingScore
            prompt
            fileReferences {
              filename
              pageNumbers
            }
          }
        }
        documentField {
          id
          name
          type
          order
        }
        attachments {
          id
          includeInAutomatedContent
          secure_blob_storage_asset {
            id
            assetKey
            url
          }
        }
        promptGroup {
          id
          prompts
          summaryPrompt
          contextPrompt
          rubricTemplates
          outputStructure
          useCustomContextPrompt
          useCustomSummaryPrompt
        }
      }
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_LIST_DOCUMENT_RECORDS_NAMES_QUERY = gql(`
  query StrategyDetailsPageListDocumentRecordsNames($data: DocumentRecordsListDto!, $fieldNames: [String!]!) {
    listDocumentRecords(data: $data) {
      total
      records {
        id
        name
        status
        statusUpdatedAt
        documentRecordFieldAnswers(fieldNames: $fieldNames) {
          id
          AI {
            answers
          }
          documentField {
            id
            name
          }
          value
        }
      }
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_LIST_DOCUMENT_RECORDS_QUERY = gql(`
  query StrategyDetailsPageListDocumentRecords($data: DocumentRecordsListDto!, $fieldNames: [String!]!) {
    listDocumentRecords(data: $data) {
      total
      limit
      offset
      records {
        id
        name
        status
        statusUpdatedAt
        owner {
          id
          firstName
          lastName
          email
        }
        sentimentFlag
        sentimentFlagLabel
        documentRecordFieldAnswers(fieldNames: $fieldNames) {
          id
          AI {
            answers
          }
          documentField {
            id
            name
          }
          value
        }
      }
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_CREATE_DOCUMENT_RECORD_MUTATION = gql(`
  mutation StrategyDetailsPageCreateDocumentRecord($data: DocumentRecordCreateDto!) {
    createDocumentRecord(data: $data) {
      id
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_UPDATE_DOCUMENT_RECORD_MUTATION = gql(`
  mutation StrategyDetailsPageUpdateDocumentRecord($data: DocumentRecordUpdateDto!) {
    updateDocumentRecord(data: $data) {
      id
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_UPDATE_DOCUMENT_FIELD_ANSWER_MUTATION = gql(`
  mutation StrategyDetailsPageUpdateDocumentFieldAnswer($data: DocumentFieldAnswerUpdateDto!) {
    updateDocumentFieldAnswer(data: $data) {
      id
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_DELETE_DOCUMENT_RECORD_MUTATION = gql(`
  mutation StrategyDetailsPageDeleteDocumentRecord($id: String!) {
    deleteDocumentRecord(id: $id)
  }
`);

export const STRATEGY_DETAILS_PAGE_UPDATE_INVESTMENT_OFFERING_MATERIALS_ATTACHMENT_MUTATION = gql(`
  mutation StrategyDetailsPageUpdateInvestmentOfferingMaterialsAttachment($data: InvestmentOfferingMaterialsUpdateAttachmentDto!) {
    updateInvestmentOfferingMaterialsAttachment(data: $data) {
      id
      asset {
        assetKey
        url
      }
      visibility
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_DELETE_DOCUMENT_FIELD_ANSWER_ATTACHMENT_MUTATION = gql(`
  mutation StrategyDetailsPageDeleteDocumentFieldAnswerAttachment($id: String!) {
    deleteDocumentFieldAnswerAttachment(id: $id)
  }
`);
